import React, { useEffect, useState } from 'react';
import { Link, useParams } from "react-router-dom";
import Layout from '../../parts/Layout';
import helpers from '../../../services/helpers';
import { httpRequest } from '../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import store from '../../../services/store';
import InputTextArea from '../../elements/InputTextArea';
import RenderErrors from '../../elements/RenderErrors';
import ProductFinderModal from '../../modals/ProductFinderModal';
import initTreeView from '../../../services/initTreeView';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { getApiData, postApiData } from '../../../services/apiService';
import { TabView, TabPanel } from 'primereact/tabview';
import { Checkbox } from 'primereact/checkbox';
import { Password } from 'primereact/password';
import { Dropdown } from 'primereact/dropdown';
 
export default function UsersForm (){
    const { user_id } = useParams();
    const [role_list, setRoleList] = useState([]);
    const [employee_list, setEmployeeList] = useState([]);
    const [vendor_list, setVendorList] = useState([]);
    const [customer_list, setCustomerList] = useState([]);
    const [loading, setLoading] = useState(0);
    const [errors, setErrors] = useState([]);
    const [page_title, setPageTitle] = useState('New User');
    const [table_items, setTableItems] = useState([]);
    /** Modals */
    const [product_modal, setProductModal] = useState(0);
    
    let default_data = {
        "id": "",
        "email": "",
        "display_name": "",
        "role_id": "",
        "reference_id": "",
        "entity_type": "",
        "password": "",
        "confirm_password": ""
    }
    let entity_types = [
        {
            "id": "system",
            "name": "System",
        },
        {
            "id": "employee",
            "name": "Employee",
        },
        {
            "id": "customer",
            "name": "Customer",
        },
        // {
        //     "id": "vendor",
        //     "name": "Vendor",
        // }
    ]
    const [form_data, setFormData] = useState(default_data);
    const [adjustment_items, setAdjustmentItems] = useState([]);
   
    useEffect(() => {
        if(user_id){
            setPageTitle('Edit User')
            fetchData(user_id)
        }else{
            fetchEnums()
        }
    }, []);

    useEffect(() => {
        initTreeView()
        //computeTotals();
    }, [adjustment_items, form_data.type_id]);

    useEffect(() => {
        fetchEnums(form_data.entity_type)
    }, [form_data.entity_type]);

    async function fetchData(){
        setLoading(1)
        const endpoint = helpers.createUrl(`V1/users/${user_id}`)
        const res = await getApiData(endpoint, false)

        if(res.status === 'error'){
            Swal.fire({
                title: "Error!",
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace("/account/users/manage");
                }
            })
        }
        else{
            setFormData(res)
            fetchEnums(res.entity_type)
        }
    }

    async function fetchEnums(entity_type = ''){
        setLoading(1)
        const roles_endpoint = helpers.createUrl(`V1/roles`)
        const roles = await getApiData(roles_endpoint)
        if(roles.status !== 'error'){
            setRoleList(roles)
            setLoading(0)
        }
        else{
            //setLoading(0)
        }
        
        if(entity_type === 'employee'){
            const employee_endpoint = helpers.createUrl(`V1/hrms/employees`)
            const employee = await getApiData(employee_endpoint)
            if(employee.status !== 'error'){
                setEmployeeList(employee)
                setLoading(0)
            }
            else{
                setLoading(0)
            }
        }
        else if(entity_type === 'vendor'){
            const vendor_endpoint = helpers.createUrl(`V1/manage/vendor/list`)
            const vendor = await getApiData(vendor_endpoint)
            if(vendor.status !== 'error'){
                setVendorList(vendor)
                setLoading(0)
            }
            else{
                setLoading(0)
            }
        }
        else if(entity_type === 'customer'){
            const customer_endpoint = helpers.createUrl(`V1/manage/contact/list`)
            const customer = await getApiData(customer_endpoint)
            if(customer.status !== 'error'){
                setCustomerList(customer)
                setLoading(0)
            }
            else{
                setLoading(0)
            }
        }
        else{
            setLoading(0)
        }
    }

    async function submit(){
        const validate = validateForm();

        if(Object.keys(validate).length){
            Swal.fire({
                text: 'Please complete all required fields in the form.',
                icon: "error",
                confirmButtonText: "OK",
            })
            return
        }
        setLoading(1)
        let endpoint = helpers.createUrl(`V1/users/create`)
        if(user_id){
            endpoint = helpers.createUrl(`V1/users/${user_id}`)
        }
        
        const res = await postApiData(endpoint,form_data)
        if(res.error_code){
            if(res.data){
                setErrors( res.data );
            }else{
                setErrors([])
            }
            setLoading(0)
        }
        else{
            let id = user_id;
            if(!id){
                id = res.data.id
            }

            Swal.fire({
                title: "Success",
                text: res.message,
                icon: "success",
                confirmButtonText: "OK",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace(`/account/users/${id}/edit`);
                    return;
                }
            })
        }
    }

    const PermissionItems = ({target_group = []}) => {
        const filteredPermissions = role_list.filter(permission => 
            target_group.includes(permission.group)
        );
        
        const handleLabelClick = (permission) => {
            const isChecked = form_data.permissions.includes(permission.id);
            const simulatedEvent = {
                target: {
                    value: permission.id,
                    checked: !isChecked, 
                },
                preventDefault: () => {}, 
            };
            
            selectSinglePermission(simulatedEvent);
        };

        return (
        <div>
            {filteredPermissions.map((permission, index) => {
                // Create a unique ID string for the checkbox and label
                const uniqueId = `permission-${permission.name.replace(/\s+/g, '-')}`;

                return (
                    <div className='d-flex' key={`permission-${permission.name}`}>
                        <Checkbox 
                            name="permission"
                            id={uniqueId} // Checkbox ID
                            onChange={selectSinglePermission}
                            value={permission.id} 
                            checked={form_data.permissions.includes(permission.id)}
                        />
                        
                        <div 
                            onClick={() => handleLabelClick(permission)}
                            className='ml-2 pointer' 
                        >
                            <span className="mb-0">{permission.display_name}</span>
                        </div>
                    </div>
                );
            })}
        </div>
        )
    }

    const SelectAllPermission = ({target_group = []}) => {
        const filteredPermissions = role_list.filter(permission => 
            target_group.includes(permission.group)
        ).map(permission => permission.id);
        
        const handleLabelClick = (permissionIds) => {
            const isChecked = filteredPermissions.some(id => form_data.permissions.includes(id));

            const simulatedEvent = {
                target: {
                    value: permissionIds,
                    checked: !isChecked, 
                },
                preventDefault: () => {}, 
            };
            
            selectMultitplePermission(simulatedEvent);
        };
        return (
            <div className='d-flex'>
                <Checkbox 
                    name="permission"
                    id={`permission-selectall`} // Checkbox ID
                    onChange={selectMultitplePermission}
                    value={filteredPermissions} 
                    checked={filteredPermissions.every(id => form_data.permissions.includes(id))}
                />
                
                <div 
                    onClick={() => handleLabelClick(filteredPermissions)}
                    className='ml-2 pointer' 
                >
                    <span className="mb-0">Select All</span>
                </div>
            </div>
        );
    }
    
    function inputChange(e) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            value = 0;
            
            if (e.target.checked) value = 1;
        }

        let new_state = { [name]: value }

        if(name === 'type_id'){
            new_state.warehouse_id = '';
        }
        if(name === 'warehouse_id'){
            setAdjustmentItems([])
        }

        setFormData({ ...form_data, ...new_state });
    }

    function selectSinglePermission(e) {
        const permissionId = Number(e.target.value); 

        // Use the function with the state updater
        setFormData(prevFormData => {
            return togglePermissionInState(prevFormData, [permissionId]);
        });
    }

    function selectMultitplePermission(e) {
        const permissionIds = e.target.value//JSON.parse(e.target.value).map(Number);
        setFormData(prevFormData => {
            return togglePermissionInState(prevFormData, permissionIds);
        });
    }

    function togglePermissionInState(prevFormData, permissionIds) {
        const currentPermissions = prevFormData.permissions;

        // Determine if all permissionIds are already selected
        const allSelected = permissionIds.every(id => currentPermissions.includes(id));

        let updatedPermissions;
        if (allSelected) {
            // Remove all permissionIds
            updatedPermissions = currentPermissions.filter(id => !permissionIds.includes(id));
        } else {
            // Add missing permissionIds
            const newPermissions = permissionIds.filter(id => !currentPermissions.includes(id));
            updatedPermissions = [...currentPermissions, ...newPermissions];
        }

        return {
            ...prevFormData,
            permissions: updatedPermissions,
        };
    }

    function validateForm(){
        let new_errors = {...errors}

        if(!form_data.email){
            new_errors['email'] = ["The email field is required."]
        }
        else{
            delete new_errors['email'];
        }

        if(!form_data.display_name){
            new_errors['display_name'] = ["The display name field is required."]
        }
        else{
            delete new_errors['display_name'];
        }

        if(!form_data.role_id){
            new_errors['role_id'] = ["The role id field is required."]
        }
        else{
            delete new_errors['role_id'];
        }

        if(!user_id){
            if(!form_data.password){
                new_errors['password'] = ["The password field is required."]
            }
            else{
                delete new_errors['password'];
            }

            if(!form_data.confirm_password){
                new_errors['confirm_password'] = ["The confirm password field is required."]
            }
            else{
                delete new_errors['confirm_password'];
            }
        }

        // if(!form_data.role_id){
        //     new_errors['role_id'] = ["The role id field is required."]
        // }
        // else{
        //     delete new_errors['role_id'];
        // }

        // if(!form_data.permissions.length){
        //     new_errors['permissions'] = ["At least one permission must be selected."]
        // }
        // else{
        //     delete new_errors['permissions'];
        // }

        setErrors(new_errors);

        return new_errors;
    }

    return (
        <Layout page_title={page_title} menu="users" breadcrumbs={true} parent_text="Account">
                <div className="content">
                    <div className="container-fluid pb-5" style={{position: 'relative'}}>
                        <Loader isLoading={loading}/>
                        <form id="pr-form">
                            <div className="row mb-2 d-flex align-items-stretch">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="card-body pt-md-5">
                                            <div className="row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-2">
                                                    <label>Email<span className="text-danger">*</span></label>
                                                </div>
                                                <div className="col-md-4 col-lg-3 form-group">
                                                    <InputText
                                                        id="email" 
                                                        name="email" 
                                                        keyfilter="email"
                                                        value={form_data.email}
                                                        className="mb-0 w-100"
                                                        onChange={inputChange}
                                                        placeholder="Email"
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="email" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-2">
                                                    <label>Display Name<span className="text-danger">*</span></label>
                                                </div>
                                                <div className="col-md-4 col-lg-3 form-group">
                                                    <InputText
                                                        id="display_name" 
                                                        name="display_name" 
                                                        value={form_data.display_name}
                                                        className="mb-0 w-100"
                                                        onChange={inputChange}
                                                        placeholder="Display Name"
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="display_name" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-2">
                                                    <label>Role<span className="text-danger">*</span></label>
                                                </div>
                                                <div className="col-md-4 col-lg-3 form-group">
                                                    <Dropdown  
                                                        name='role_id'
                                                        value={form_data.role_id} 
                                                        onChange={inputChange} 
                                                        options={role_list} 
                                                        optionLabel="name" 
                                                        optionValue="id" 
                                                        placeholder="Select Role" 
                                                        className="w-100" 
                                                        checkmark={true} 
                                                        highlightOnSelect={false}
                                                        showClear
                                                        filter 
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="display_name" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>

                                                <div className="row">
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-2">
                                                        <label>Type</label>
                                                    </div>
                                                    <div className="col-md-4 col-lg-3 form-group">
                                                        <Dropdown  
                                                            name='entity_type'
                                                            value={!form_data.entity_type ? 'system' : form_data.entity_type} 
                                                            onChange={inputChange} 
                                                            options={entity_types} 
                                                            optionLabel="name" 
                                                            optionValue="id" 
                                                            placeholder="Select User Type" 
                                                            className="w-100" 
                                                            checkmark={true} 
                                                            highlightOnSelect={false}
                                                            showClear
                                                            filter 
                                                        />
                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="reference_id" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div>
                                            {
                                                form_data.entity_type === 'employee' ?
                                                <div className="row">
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-2">
                                                        <label>Linked Employee</label>
                                                    </div>
                                                    <div className="col-md-4 col-lg-3 form-group">
                                                        <Dropdown  
                                                            name='reference_id'
                                                            value={form_data.reference_id} 
                                                            onChange={inputChange} 
                                                            options={employee_list} 
                                                            optionLabel="full_name" 
                                                            optionValue="id" 
                                                            placeholder="Select Employee" 
                                                            className="w-100" 
                                                            checkmark={true} 
                                                            highlightOnSelect={false}
                                                            showClear
                                                            filter 
                                                        />
                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="reference_id" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div> : ''
                                            }

                                            {
                                                form_data.entity_type === 'vendor' ?
                                                <div className="row">
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-2">
                                                        <label>Linked Vendor</label>
                                                    </div>
                                                    <div className="col-md-4 col-lg-3 form-group">
                                                        <Dropdown  
                                                            name='reference_id'
                                                            value={form_data.reference_id} 
                                                            onChange={inputChange} 
                                                            options={vendor_list} 
                                                            optionLabel="vendor_name" 
                                                            optionValue="id" 
                                                            placeholder="Select Vendor" 
                                                            className="w-100" 
                                                            checkmark={true} 
                                                            highlightOnSelect={false}
                                                            showClear
                                                            filter 
                                                        />
                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="reference_id" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div> : ''
                                            }

                                            {
                                                form_data.entity_type === 'customer' ?
                                                <div className="row">
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-2">
                                                        <label>Linked Customer</label>
                                                    </div>
                                                    <div className="col-md-4 col-lg-3 form-group">
                                                        <Dropdown  
                                                            name='reference_id'
                                                            value={form_data.reference_id} 
                                                            onChange={inputChange} 
                                                            options={customer_list} 
                                                            optionLabel="contact_name" 
                                                            optionValue="id" 
                                                            placeholder="Select Customer" 
                                                            className="w-100" 
                                                            checkmark={true} 
                                                            highlightOnSelect={false}
                                                            showClear
                                                            filter 
                                                        />
                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="reference_id" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div> : ''
                                            }

                                            {
                                                user_id ? 
                                                <div className='row mb-2'>
                                                    <div className="col-md-3" />
                                                    <div className="col-md-4">
                                                        <small>Note: Leave both password fields empty to keep the current password.</small>
                                                    </div>
                                                </div> : ''
                                            }
                                            
                                            <div className="row">
                                                <div className="col-12"></div>
                                                <div className="col-md-1"></div>
                                                <div className="col-md-2">
                                                    <label>Password<span className="text-danger">*</span></label>
                                                </div>
                                                <div className="col-md-4 col-lg-3 form-group">
                                                    <InputText
                                                        id="password" 
                                                        name="password"
                                                        type="password"
                                                        value={form_data.password}
                                                        className="mb-0 w-100"
                                                        onChange={inputChange}
                                                        placeholder="Password"
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="password" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12"></div>
                                                <div className="col-md-1"></div>
                                                <div className="col-md-2">
                                                    <label>Confirm Password<span className="text-danger">*</span></label>
                                                </div>
                                                <div className="col-md-4 col-lg-3 form-group">
                                                    <InputText
                                                        id="confirm_password" 
                                                        name="confirm_password"
                                                        type="password"
                                                        value={form_data.confirm_password}
                                                        className="mb-0 w-100"
                                                        onChange={inputChange}
                                                        placeholder="Password"
                                                    />
                                                    <RenderErrors 
                                                        errors={errors} 
                                                        name="confirm_password" 
                                                        className="text-danger"
                                                        style={{fontSize: '.9rem'}}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='text-right mt-3'>
                                <button type='button' className='btn btn-success mr-3 ' onClick={(e) => submit(1)}>Save</button>
                                <Link className='btn btn-outline-dark' to="/account/users/manage">Cancel</Link>                   
                            </div>
                        </form>
                    </div>
                </div>
        </Layout>
    )
}